// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/ordini-fornitori/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","societaId":"number","sedeId":"number","fornitoreId":"number","stato":"BOZZA|EMESSO|CHIUSO|ANNULLATO","numero":"string|null","dataEmissione":"string|null","fornitoreRagioneSociale":"string|null","fornitorePartitaIva":"string|null","note":"string|null","createdAt":"string","annullatoAt":"string|null","fornitore":{"id":"number","ragioneSociale":"string","partitaIva":"string|null"},"sede":{"id":"number","nome":"string"},"createdBy":{"id":"number","nome":"string"},"annullatoDa":{"id":"number","nome":"string"},"chiusoAt":"string|null","motivoChiusura":"string|null","chiusuraAutomatica":"boolean","chiusoDa":{"id":"number","nome":"string"},"righe":[{"id":"number","ordinePos":"number","articoloId":"number|null","descrizione":"string","unitaMisura":"string|null","quantita":"number","prezzoUnitarioAtteso":"number|null","quantitaRicevuta":"number","note":"string|null","rigaRdaId":"number|null","articolo":{"id":"number","codice":"string","descrizioneBase":"string"},"rigaRda":{"id":"number","rda":{"id":"number","numero":"number","anno":"number"},"ordine":{"id":"number","numero":"string"},"commessa":{"id":"number","numero":"string","descrizione":"string"}}}],"logs":[{"id":"number","utenteName":"string","azione":"string","dettaglio":"string","createdAt":"string"}],"carichi":[{"id":"number","numero":"number|null","anno":"number|null","data":"string","stato":"string","numeroDocumentoEsterno":"string|null","dataDocumentoEsterno":"string|null","storno":"boolean","righe":"number"}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/sedi?societaId=',
    requestBody: null,
    response: '{"sedi":[{"id":"number","nome":"string","societaId":"number"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/ordini-fornitori/:id/emetti',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"EMESSO","numero":"string","dataEmissione":"string"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/ordini-fornitori/:id',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/ordini-fornitori/:id/annulla',
    requestBody: '{"motivo":"string|null"}',
    response: '{"success":true,"data":{"stato":"ANNULLATO"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/ordini-fornitori/:id/chiudi',
    requestBody: '{"motivo":"string"}',
    response: '{"success":true,"data":{"stato":"CHIUSO"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/ordini-fornitori/:id/riapri',
    requestBody: null,
    response: '{"success":true,"data":{"stato":"EMESSO"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/ordini-fornitori/:id',
    requestBody: '{"note":"string|null","sedeId":"number"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/ordini-fornitori/:id',
    requestBody: '{"righe":[{"rigaRdaId":"number|null","articoloId":"number|null","descrizione":"string","unitaMisura":"string|null","quantita":"number","prezzoUnitarioAtteso":"number|null","note":"string|null"}]}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
